import React, { useEffect } from "react";

import {
  FaAngleDown,
  FaAngleUp,
  FaArrowCircleRight,
  FaClock,
  FaDownload,
  FaExclamationTriangle,
  FaInfoCircle,
  FaLock,
  FaPen,
  FaRegTrashAlt,
  FaSearch,
  FaTimesCircle,
  FaUnlockAlt,
  FaUserLock,
  FaUserSlash,
} from "react-icons/fa";
import { FormattedMessage } from "react-intl";
import TooltipWrapper from "../../ui/TooltipWrapper/TooltipWrapper";
import Status from "../Status/Status";

//style & scss
import classes from "./Table.module.scss";

//messages & translations
import { MdPersonOutline, MdReplayCircleFilled } from "react-icons/md";
import { generalConst } from "../../module/globalInterface";
import { hideCells, hideColumns } from "./module/constants";
import messages from "./module/messages";

//constanti per la costruzioni delle tabelle
const STATUS_HEADER: string = "STATUS";
const CERTIFICATIONITEMSTATUS_HEADER: string = "STATUS";
const DETAIL_HEADER: string = "DETAIL";
const USER_DETAIL_HEADER: string = "USER_DETAIL";
const WARNING_HEADER: string = "WARNING";
const DELETE_HEADER: string = "DELETE";
const MODIFY_HEADER: string = "MODIFY";
const DOWNLOAD_HEADER: string = "DOWNLOAD";
const SELECTION_HEADER: string = "SELECTION";
const VIOLATION_VISIBILITY_WARNING: string = "VIOLATION_OF_VISIBILITY";
const TEMPORARY: string = "TEMPORARY";
const BUSINESS_ROLES: string = "BUSINESS_ROLES";
const PASSWORD: string = "PASSWORD";
const UNLOCK_HEADER: string = "UNLOCK";
const RESET_HEADER: string = "RESET";
const CHANGE_HEADER: string = "CHANGE";
const BLOCK_HEADER: string = "BLOCK";
const REPLAYABLE_HEADER: string = "REPLAY";
const RELATIONSHIP_END_DATE_HEADER = "RELATIONSHIPENDDATE";

//interfaccia per la costruzione dei singoli elementi della tabella
export interface IdataTableConstructor {
  id: string;
  thHeadAll: Function;
  iconRow: Function;
  tdBodyRow: Function;
  tdHeadRow: Function;
}

//interfaccia creazione checkbox for table
interface ICheckBoxProps {
  indeterminate?: boolean;
}

//JSX const element for tdbody
export const tdBodyRowElement = (cell: any, customHideCells: generalConst) => {
  const combinedHideCells = { ...hideCells, ...customHideCells };
  if (combinedHideCells[cell.column.Header]) {
    return;
  } else if (
    cell.column.Header === RELATIONSHIP_END_DATE_HEADER &&
    cell.value === "01/01/1970"
  ) {
    return (
      <td className={classes.td} {...cell.getCellProps()}>
        {""}
      </td>
    );
  } else if (cell.column.Header === STATUS_HEADER) {
    return (
      <td className={classes.status} {...cell.getCellProps()}>
        <Status status={cell.value} />
      </td>
    );
  } else if (
    cell.column.id === DETAIL_HEADER ||
    cell.column.id === DELETE_HEADER ||
    cell.column.id === MODIFY_HEADER ||
    cell.column.id === DOWNLOAD_HEADER
  ) {
    return (
      <td className={classes.td} {...cell.getCellProps()}>
        {cell.render("Cell")}
      </td>
    );
  } else if (
    cell.column.Header === "TYPE" ||
    cell.column.Header === "ACTION" ||
    cell.column.Header ===
      "VALUESYSTEMPROPERTYADMINAPPLICATIONSABILITATIONSMGMT" ||
    cell.column.Header ===
      "SHOW_ON_FRONTEND_CONSOLE_ADMIN_APPLICATIONS_ABILITATIONS_MGMT"
  ) {
    const messagesKey = cell.render("Cell").props.value;
    return (
      <td className={classes.td} {...cell.getCellProps()}>
        {/* {cell.render("Cell")} */}
        {messages[messagesKey as keyof typeof messages] ? (
          <FormattedMessage
            {...messages[messagesKey as keyof typeof messages]}
          />
        ) : (
          messagesKey
        )}
      </td>
    );
  } else if (
    cell.column.id === UNLOCK_HEADER ||
    cell.column.id === RESET_HEADER ||
    cell.column.id === CHANGE_HEADER ||
    cell.column.id === BLOCK_HEADER
  ) {
    return (
      <TooltipWrapper
        key={`pwdOperations-${Math.random()}`}
        content={
          <FormattedMessage
            {...messages[cell.column.id as keyof typeof messages]}
          />
        }
      >
        <td className={classes.td} {...cell.getCellProps()}>
          {cell.render("Cell")}
        </td>
      </TooltipWrapper>
    );
  }
  return (
    <TooltipWrapper key={`${cell.value}-${Math.random()}`} content={cell.value}>
      <td className={classes.td} {...cell.getCellProps()}>
        {cell.render("Cell")}
      </td>
    </TooltipWrapper>
  );
};

export const thHeadRowElement = (
  column: any,
  customHideColumns: generalConst
) => {
  const combinedHideColums = { ...hideColumns, ...customHideColumns };
  const messagesKey = column.render("Header");
  // console.log(messagesKey,'messagesKey')
  // HIDE COLUMN
  if (combinedHideColums[column.id]) {
    return;
  } else {
    return (
      <th
        className={classes.th}
        {...column.getHeaderProps(column.getSortByToggleProps())}
      >
        {messages[messagesKey as keyof typeof messages] ? (
          <FormattedMessage
            {...messages[messagesKey as keyof typeof messages]}
          />
        ) : (
          messagesKey
        )}
        <span>
          {column.isSorted ? (
            column.isSortedDesc ? (
              <FaAngleDown />
            ) : (
              <FaAngleUp />
            )
          ) : (
            ""
          )}
        </span>
      </th>
    );
  }
};

//oggetti che costruiscono la tabella
export const dataTableDetail: IdataTableConstructor = {
  id: DETAIL_HEADER,
  thHeadAll: () => <div></div>,
  iconRow: (props: any) => {
    const goToDetailHandler = () => {
      props.onDetailClick(props.row.original);
      props.changeLocation(props.detailURL);
    };
    const forwardDetail = () => {
      props.onDetailClick(props.row.original);
    };
    if (props.summaryDetail) {
      if (
        props.row.original.available === false ||
        props.row.original.available === "undefined" ||
        props.row.values.available === false ||
        props.row.values.available === "undefined"
      ) {
        return null;
      }
      return (
        <FaArrowCircleRight
          className={classes.search}
          onClick={
            props.changeLocation && props.detailURL
              ? () => {
                  goToDetailHandler();
                }
              : props.onDetailClick
              ? () => {
                  forwardDetail();
                }
              : () => {}
          }
        />
      );
    }
    return (
      <FaSearch
        className={classes.search}
        onClick={
          props.changeLocation && props.detailURL
            ? () => {
                goToDetailHandler();
              }
            : props.onDetailClick
            ? () => {
                forwardDetail();
              }
            : () => {}
        }
      />
    );
  },
  tdBodyRow: (cell: any, customHideCells: generalConst) =>
    tdBodyRowElement(cell, customHideCells),
  tdHeadRow: (column: any, customHideColumns: generalConst) =>
    thHeadRowElement(column, customHideColumns),
};

export const dataTableUserDetail: IdataTableConstructor = {
  id: USER_DETAIL_HEADER,
  thHeadAll: () => <div></div>,
  iconRow: (props: any) => {
    const forwardUserDetail = () => {
      props.onUserDetailClick(props.row.original);
    };
    return (
      <MdPersonOutline
        className={classes.search}
        onClick={
          props.onUserDetailClick
            ? () => {
                forwardUserDetail();
              }
            : () => {}
        }
      />
    );
  },
  tdBodyRow: (cell: any, customHideCells: generalConst) =>
    tdBodyRowElement(cell, customHideCells),
  tdHeadRow: (column: any, customHideColumns: generalConst) =>
    thHeadRowElement(column, customHideColumns),
};

export const dataTableWarning: IdataTableConstructor = {
  id: WARNING_HEADER,
  thHeadAll: () => <div></div>,
  iconRow: () => {
    return <FaExclamationTriangle className={classes.search} />;
  },
  tdBodyRow: (cell: any, customHideCells: generalConst) =>
    tdBodyRowElement(cell, customHideCells),
  tdHeadRow: (column: any, customHideColumns: generalConst) =>
    thHeadRowElement(column, customHideColumns),
};

export const dataTableViolationVisibility: IdataTableConstructor = {
  id: VIOLATION_VISIBILITY_WARNING,
  thHeadAll: () => <div></div>,
  iconRow: (props: any) => {
    if (
      (props.row &&
        props.row.values &&
        props.row.values.violationOfVisibility) ||
      (props.row &&
        props.row.original &&
        props.row.original.violationOfVisibility)
    ) {
      return (
        <TooltipWrapper
          key={`${Math.random()}`}
          content={
            <FormattedMessage {...messages.violationOfVisibilityMessage} />
          }
        >
          <div>
            <FaExclamationTriangle className={classes.warning} />
          </div>
        </TooltipWrapper>
      );
    }
    return null;
  },
  tdBodyRow: (cell: any, customHideCells: generalConst) =>
    tdBodyRowElement(cell, customHideCells),
  tdHeadRow: (column: any, customHideColumns: generalConst) =>
    thHeadRowElement(column, customHideColumns),
};

export const dataTableTemporary: IdataTableConstructor = {
  id: TEMPORARY,
  thHeadAll: () => <div></div>,
  iconRow: (props: any) => {
    if (
      (props.row && props.row.values && props.row.values.temporary) ||
      (props.row && props.row.original && props.row.original.temporary)
    ) {
      // console.log("entro");
      return (
        <TooltipWrapper
          key={`${Math.random()}`}
          content={<FormattedMessage {...messages.temporaryMessage} />}
        >
          <div>
            <FaClock className={classes.search} />
          </div>
        </TooltipWrapper>
      );
    }
    return null;
  },
  tdBodyRow: (cell: any, customHideCells: generalConst) =>
    tdBodyRowElement(cell, customHideCells),
  tdHeadRow: (column: any, customHideColumns: generalConst) =>
    thHeadRowElement(column, customHideColumns),
};

export const dataTableBR: IdataTableConstructor = {
  id: BUSINESS_ROLES,
  thHeadAll: () => <div></div>,
  iconRow: (props: any) => {
    // console.log(props, "props");
    const { onInfoBR, row } = props;
    let id: string = "";
    // console.log(props, "props");
    if (row) {
      id = row.values.id ? row.values.id : row.original.entitlement_id;
    }
    if (
      (props.row && props.row.values && props.row.values.isBR) ||
      (props.row && props.row.original && props.row.original.isBR)
    ) {
      return (
        <FaInfoCircle
          onClick={() => onInfoBR(id, row)}
          className={classes.search}
        />
      );
    }
    return null;
  },
  tdBodyRow: (cell: any, customHideCells: generalConst) =>
    tdBodyRowElement(cell, customHideCells),
  tdHeadRow: (column: any, customHideColumns: generalConst) =>
    thHeadRowElement(column, customHideColumns),
};

export const dataTableDelete: IdataTableConstructor = {
  id: DELETE_HEADER,
  thHeadAll: () => <div></div>,
  iconRow: (props: any) => {
    const { row, onDeleteRow } = props;
    let id: string = "";
    if (row) {
      id = row.id ? row.id : row.original.entitlement_id;
    }
    const { values, original } = row;
    if (
      (typeof original.editable !== "undefined" &&
        original.editable === false) ||
      (typeof values.editable !== "undefined" && values.editable === false) ||
      (typeof values.deleteAllowed !== "undefined" &&
        values.deleteAllowed === false)
    ) {
      return null;
    }
    if (values.deleted || original.deleted) {
      return (
        <FaTimesCircle
          className={classes.search}
          onClick={
            onDeleteRow && id
              ? () => {
                  return onDeleteRow(id);
                }
              : () => {}
          }
        />
      );
    }

    return (
      <FaRegTrashAlt
        className={classes.search}
        onClick={
          onDeleteRow && id
            ? () => {
                return onDeleteRow(id);
              }
            : () => {}
        }
      />
    );
  },
  tdBodyRow: (cell: any, customHideCells: generalConst) =>
    tdBodyRowElement(cell, customHideCells),
  tdHeadRow: (column: any, customHideColumns: generalConst) =>
    thHeadRowElement(column, customHideColumns),
};

export const dataTableModify: IdataTableConstructor = {
  id: MODIFY_HEADER,
  thHeadAll: () => <div></div>,
  iconRow: (props: any) => {
    const { row, onEditRow } = props;
    let id: string = "";
    if (props.row) {
      id = row.id ? row.id : row.original.entitlement_id;
    }
    const { values } = row;
    if (typeof values.editable !== "undefined" && values.editable === false) {
      return null;
    }
    if (typeof values.added !== "undefined" && values.added === false) {
      return null;
    }
    return (
      <FaPen
        className={classes.search}
        onClick={
          onEditRow && id
            ? () => {
                props.onEditRow(id);
              }
            : () => {}
        }
      />
    );
  },
  tdBodyRow: (cell: any, customHideCells: generalConst) =>
    tdBodyRowElement(cell, customHideCells),
  tdHeadRow: (column: any, customHideColumns: generalConst) =>
    thHeadRowElement(column, customHideColumns),
};

export const dataTableDownload: IdataTableConstructor = {
  id: DOWNLOAD_HEADER,
  thHeadAll: () => <div></div>,
  iconRow: (props: any) => {
    const { row, onDownloadRow } = props;
    let id: string = "";
    if (props.row) {
      id = row.id && row.id;
    }
    const { values } = row;
    return (
      <FaDownload
        className={classes.search}
        onClick={
          onDownloadRow && id
            ? () => {
                props.onDownloadRow(id);
              }
            : () => {}
        }
      />
    );
  },
  tdBodyRow: (cell: any, customHideCells: generalConst) =>
    tdBodyRowElement(cell, customHideCells),
  tdHeadRow: (column: any, customHideColumns: generalConst) =>
    thHeadRowElement(column, customHideColumns),
};

export const dataTableCheckbox: IdataTableConstructor = {
  id: SELECTION_HEADER,
  thHeadAll: ({ getToggleAllPageRowsSelectedProps }: any) => {
    const globalCheckboxProps = {
      onChange: getToggleAllPageRowsSelectedProps().onChange,
      style: getToggleAllPageRowsSelectedProps().style,
      checked: getToggleAllPageRowsSelectedProps().checked,
      indeterminate: getToggleAllPageRowsSelectedProps().indeterminate,
    };
    return <TableCheckbox {...globalCheckboxProps} />;
  },
  iconRow: (props: any) => {
    // console.log("propsRow", props);
    return <TableCheckbox {...props.row.getToggleRowSelectedProps()} />;
  },
  tdBodyRow: (cell: any, customHideCells: generalConst) =>
    tdBodyRowElement(cell, customHideCells),
  tdHeadRow: (column: any, customHideColumns: generalConst) =>
    thHeadRowElement(column, customHideColumns),
};

// creazione checkbox for table
export const TableCheckbox = React.forwardRef<HTMLInputElement, ICheckBoxProps>(
  ({ indeterminate, ...rest }, ref) => {
    const defaultRef = React.useRef();
    const resolvedRef: any = ref || defaultRef;
    useEffect(() => {
      resolvedRef.current.indeterminate = indeterminate;
    }, [resolvedRef, indeterminate]);
    return (
      <>
        <input
          className={classes.checkbox}
          type="checkbox"
          ref={resolvedRef}
          {...rest}
        />
      </>
    );
  }
);

export const dataTablePassword: IdataTableConstructor = {
  id: PASSWORD,
  thHeadAll: () => <div></div>,
  iconRow: (props: any) => {
    const { onPasswordClick, row } = props;
    let id: string = "";
    if (row) {
      id = row.id ? row.id : row.original.id_user;
    }
    if ((props.row && props.row.values) || (props.row && props.row.original)) {
      return (
        <FaUnlockAlt
          onClick={() => onPasswordClick(id)}
          className={classes.search}
        />
      );
    }
    return null;
  },
  tdBodyRow: (cell: any, customHideCells: generalConst) =>
    tdBodyRowElement(cell, customHideCells),
  tdHeadRow: (column: any, customHideColumns: generalConst) =>
    thHeadRowElement(column, customHideColumns),
};

export const dataTableUnlock: IdataTableConstructor = {
  id: UNLOCK_HEADER,
  thHeadAll: () => <div></div>,
  iconRow: (props: any) => {
    const { row, onUnlockRow } = props;
    let id: string = "";
    if (props.row) {
      id = row.id ? row.id : row.original.entitlement_id;
    }
    const { values } = row;
    if (typeof values.editable !== "undefined" && values.editable === false) {
      return null;
    }
    return (
      <FaUnlockAlt
        className={classes.search}
        onClick={
          onUnlockRow && id
            ? () => {
                props.onUnlockRow(id);
              }
            : () => {}
        }
      />
    );
  },
  tdBodyRow: (cell: any, customHideCells: generalConst) =>
    tdBodyRowElement(cell, customHideCells),
  tdHeadRow: (column: any, customHideColumns: generalConst) =>
    thHeadRowElement(column, customHideColumns),
};

export const dataTableReset: IdataTableConstructor = {
  id: RESET_HEADER,
  thHeadAll: () => <div></div>,
  iconRow: (props: any) => {
    const { row, onResetRow } = props;
    let id: string = "";
    if (props.row) {
      id = row.id ? row.id : row.original.entitlement_id;
    }
    const { values } = row;
    if (typeof values.editable !== "undefined" && values.editable === false) {
      return null;
    }
    return (
      <FaLock
        className={classes.search}
        onClick={
          onResetRow && id
            ? () => {
                props.onResetRow(id);
              }
            : () => {}
        }
      />
    );
  },
  tdBodyRow: (cell: any, customHideCells: generalConst) =>
    tdBodyRowElement(cell, customHideCells),
  tdHeadRow: (column: any, customHideColumns: generalConst) =>
    thHeadRowElement(column, customHideColumns),
};

export const dataTableChange: IdataTableConstructor = {
  id: CHANGE_HEADER,
  thHeadAll: () => <div></div>,
  iconRow: (props: any) => {
    const { row, onChangeRow } = props;
    let id: string = "";
    if (props.row) {
      id = row.id ? row.id : row.original.entitlement_id;
    }
    const { values } = row;
    if (typeof values.editable !== "undefined" && values.editable === false) {
      return null;
    }
    return (
      <FaUserLock
        className={classes.search}
        onClick={
          onChangeRow && id
            ? () => {
                props.onChangeRow(id);
              }
            : () => {}
        }
      />
    );
  },
  tdBodyRow: (cell: any, customHideCells: generalConst) =>
    tdBodyRowElement(cell, customHideCells),
  tdHeadRow: (column: any, customHideColumns: generalConst) =>
    thHeadRowElement(column, customHideColumns),
};

export const dataTableBlock: IdataTableConstructor = {
  id: BLOCK_HEADER,
  thHeadAll: () => <div></div>,
  iconRow: (props: any) => {
    const { row, onBlockRow } = props;
    let id: string = "";
    if (props.row) {
      id = row.id ? row.id : row.original.entitlement_id;
    }
    const { values } = row;
    if (typeof values.editable !== "undefined" && values.editable === false) {
      return null;
    }
    return (
      <FaUserSlash
        className={classes.search}
        onClick={
          onBlockRow && id
            ? () => {
                props.onBlockRow(id);
              }
            : () => {}
        }
      />
    );
  },
  tdBodyRow: (cell: any, customHideCells: generalConst) =>
    tdBodyRowElement(cell, customHideCells),
  tdHeadRow: (column: any, customHideColumns: generalConst) =>
    thHeadRowElement(column, customHideColumns),
};

export const dataTableReplayable: IdataTableConstructor = {
  id: REPLAYABLE_HEADER,
  thHeadAll: () => <div></div>,
  iconRow: (props: any) => {
    const { row, onReplay } = props;
    let id: string = "";
    if (props.row) {
      id = row.id ? row.id : row.original.entitlement_id;
    }
    const { values } = row;
    if (typeof values.editable !== "undefined" && values.editable === false) {
      return null;
    }
    return (
      <MdReplayCircleFilled
        className={classes.replay}
        onClick={
          onReplay && id
            ? () => {
                props.onReplay(id);
              }
            : () => {}
        }
      />
    );
  },
  tdBodyRow: (cell: any, customHideCells: generalConst) =>
    tdBodyRowElement(cell, customHideCells),
  tdHeadRow: (column: any, customHideColumns: generalConst) =>
    thHeadRowElement(column, customHideColumns),
};

export const checkDatasourceForWrapText = (
  datasource: any[]
): any[] | undefined => {
  if (!datasource || !Array.isArray(datasource)) {
    return;
  }
  datasource.forEach((element) => {
    Object.keys(element).forEach((key) => {
      if (typeof element[key] === "string" && element[key].includes(`\n`)) {
        let temp = element[key].replace(/(\r\n|\n|\r)/g, " ");
        element[key] = temp;
      }
    });
  });
  return datasource;
};
